<div class="leah-layout">
  <aside class="leah-sidebar">
    <img src="app_logo.svg" alt="leah Logo" class="leah-sidebar__logo">

    <nav class="leah-sidebar__nav">
      <p-menu [model]="menuItems()" styleClass="leah-sidebar-menu" />
    </nav>

    <div class="leah-sidebar__footer">
      <p-button label="Abmelden" icon="pi pi-sign-out" severity="secondary" [text]="true" (onClick)="logout()"
        styleClass="w-full" />
    </div>
  </aside>

  <main class="leah-content">
    <router-outlet />
  </main>
</div>